import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ObjectPageComponent} from "../../../../../core/shared/object/mvs-object-page-component/object-page.component";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";

// NOT_IN_USE
@Component({
    selector: 'mvs-customer-overview-page',
    templateUrl: 'customer-overview-consultant.page.html',
    standalone: false
})
export class CustomerOverviewConsultantPage extends ObjectPageComponent implements OnInit, OnChanges, OnDestroy {

  override defaultLabel: string = "Customer Overview";

  customerId: number;

  constructor(protected override route: ActivatedRoute,
              protected override coreService: MvsCoreService) {
    super(route, coreService)
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {

    // Option 1: Snapshot (static, only works when component is first loaded)
    this.customerId = +this.route.snapshot.paramMap.get('id')!;

    // Option 2: Observable (updates if the same component is reused with different id)
    this.route.paramMap.subscribe(params => {
      this.customerId = +params.get('id')!;
    });

    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  override refreshComponent() {
    this.initialized = true;
  }

  protected override getObjectType(): string {
    return "cr.Customer";
  }


  /**
   * Process changes within Binding.
   * @param changes
   */
  override ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["id"]) {
      this.refreshComponent();
    }
  }

  /**
   * Destroy component.
   */
  override ngOnDestroy(): void {

  }
}
